module.exports = __webpack_public_path__ + "Flag-499.80115e25ae26c607c9521344a3713b6d.svg";